<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary, secondary, firstStopColor, secondStopColor } =
    $AppState.theme.colors.illustration;
</script>

<svg
  width="48"
  height="48"
  viewBox="0 0 48 48"
  fill="none"
  class="twism-lock-indicator"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="24" cy="24" r="24" fill="url(#paint0_linear)" />
  <path
    d="M17.751 21.75V16.75C17.751 15.0924 18.4095 13.5027 19.5816 12.3306C20.7537 11.1585 22.3434 10.5 24.001 10.5C25.6586 10.5 27.2483 11.1585 28.4204 12.3306C29.5925 13.5027 30.251 15.0924 30.251 16.75V21.75"
    stroke={primary}
    stroke-width="2.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M32.5556 22H15.4444C14.0944 22 13 23.221 13 24.7273V34.2727C13 35.779 14.0944 37 15.4444 37H32.5556C33.9056 37 35 35.779 35 34.2727V24.7273C35 23.221 33.9056 22 32.5556 22Z"
    fill={secondary}
    stroke={secondary}
    stroke-width="2.4"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M25.7639 29.8632C26.1978 29.4556 26.4687 28.8766 26.4687 28.2344C26.4687 27.0004 25.4684 26 24.2344 26C23.0004 26 22 27.0004 22 28.2344C22 28.9866 22.3717 29.652 22.9415 30.0569L22.9415 32.115C22.9415 32.8944 23.5733 33.5262 24.3527 33.5262C25.1321 33.5262 25.7639 32.8944 25.7639 32.115L25.7639 29.8632Z"
    fill={primary}
  />
  <defs>
    <linearGradient
      id="paint0_linear"
      x1="24"
      y1="0"
      x2="24"
      y2="36.5533"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color={firstStopColor} />
      <stop offset="1" stop-color={secondStopColor} />
    </linearGradient>
  </defs>
</svg>

<style lang="scss">
  .twism-lock-indicator {
    min-width: 48px;
    min-height: 48px;
  }
</style>
